"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirebaseAnalytics = exports.App = void 0;
const analytics_1 = require("firebase/analytics");
const app_1 = require("firebase/app");
const react_native_config_1 = __importDefault(require("react-native-config"));
exports.App = (0, app_1.initializeApp)({
    apiKey: react_native_config_1.default.FIREBASE_KEY,
    authDomain: react_native_config_1.default.FIREBASE_URL,
    projectId: react_native_config_1.default.GCP_PROJECT,
    storageBucket: react_native_config_1.default.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: react_native_config_1.default.FIREBASE_MESSAGING_SENDER_ID,
    appId: react_native_config_1.default.FIREBASE_APP_ID,
    measurementId: react_native_config_1.default.FIREBASE_ANALYTICS_ID
}, "elevate_analytics");
class FirebaseAnalytics {
    _analytics;
    constructor() {
        this._analytics = (0, analytics_1.getAnalytics)(exports.App);
    }
    LogEvent(eventName, params) {
        (0, analytics_1.logEvent)(this._analytics, eventName, params);
    }
    LogScreen(screen_name, screen_class) {
        (0, analytics_1.logEvent)(this._analytics, 'screen_view', {
            firebase_screen: screen_name,
            firebase_screen_class: screen_class
        });
    }
}
exports.FirebaseAnalytics = FirebaseAnalytics;
const CloudLogger = new FirebaseAnalytics();
exports.default = CloudLogger;
